module.exports = __webpack_public_path__ + "img/KJKRegistrations_White_Small.00ac2aab.png";